import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './ACGallery.css';
import  project1  from '../assets/project1.jpeg';
import  project2  from '../assets/project2.jpeg';
import  project3  from '../assets/project3.png';
import  project4  from '../assets/project4.png';
import  project5  from '../assets/project5.png';

const images = [
  { id: 1, title: 'Central AC Install', url: project1 },
  { id: 2, title: 'Duct Repair', url: project2 },
  { id: 3, title: 'Smart Thermostat', url: project3 },
  { id: 4, title: 'Commercial Units', url: project4 },
  { id: 5, title: 'Maintenance Check', url: project5 },
];

const ACGallery = () => {
  const [index, setIndex] = useState(2);

  const nextStep = () => setIndex((prev) => (prev + 1) % images.length);
  const prevStep = () => setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <p className="sub-heading">Our Work Gallery</p>
        <h2 className="main-heading">Explore our journey through impactful projects and creative solutions</h2>
      </div>

      <div className="carousel-wrapper">
        <div className="images-container">
          {images.map((img, i) => {
            // Calculate relative position (-2, -1, 0, 1, 2)
            // ... inside images.map
let position = i - index;
if (position < -2) position += images.length;
if (position > 2) position -= images.length;

// Determine horizontal scale based on position
// Position 0 = Center (1)
// Position -1, 1 = Inner Sides (0.85)
// Position -2, 2 = Outer Ends (Increased to 0.9 for horizontal prominence)
const calculateScale = () => {
  if (position === 0) return 1;
  if (Math.abs(position) === 1) return 0.85;
  return 0.80; // This makes the first and last images quite large
};

return (
  <motion.div
    key={img.id}
    className="card"
    initial={false}
    animate={{
      // Increase the multiplier to spread them out so the large ends don't overlap
      x: position * 280, 
      scale: calculateScale(),
      // Flatten the rotation for the far ends to make them look "wider"
      rotateY: position === 0 ? 0 : (position > 0 ? 25 : -25),
      zIndex: 10 - Math.abs(position),
      opacity: 1,
    }}
    transition={{ type: 'spring', stiffness: 200, damping: 25 }}
    onClick={() => setIndex(i)}
  >
    <img src={img.url} alt={img.title} />
    {/* ... rest of your content */}
  </motion.div>
);
          })}
        </div>
      </div>

      <div className="controls">
        <button onClick={prevStep} className="nav-btn">←</button>
        <button onClick={nextStep} className="nav-btn">→</button>
      </div>
    </div>
  );
};

export default ACGallery;